import { Pipe, PipeTransform } from '@angular/core';
import { API_URLS } from './utils/API_URLS';

@Pipe({
  name: 'serverImage'
})
export class ServerImagePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return API_URLS.File.download + value;
  }

}
